"use client";

import { CapabilityIcons } from "./CapabilityIcons";
import type { AgentCapabilities } from "./AgentCard";

interface AssistantRowProps {
  name: string;
  description?: string;
  onClick: () => void;
  capabilities?: AgentCapabilities;
}

// Compact assistant row for the multi-space landing list. Every assistant renders
// identically — there is no flagship highlight.
export default function AssistantRow({
  name,
  description,
  onClick,
  capabilities,
}: AssistantRowProps) {
  return (
    <button
      onClick={onClick}
      className="relative flex w-full cursor-pointer items-start gap-2 px-[14px] py-2.5 text-left transition-colors hover:bg-bg-hover"
    >
      <div className="min-w-0 flex-1">
        <span
          className="block truncate"
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: "var(--fg)",
          }}
        >
          {name}
        </span>
        {description && (
          <span
            className="block truncate"
            style={{
              marginTop: 2,
              fontSize: 12,
              color: "var(--fg-secondary)",
              lineHeight: 1.4,
            }}
          >
            {description}
          </span>
        )}
      </div>
      {capabilities && (
        <div style={{ marginTop: 2, flexShrink: 0 }}>
          <CapabilityIcons
            useSharedWorkspace={capabilities.useSharedWorkspace}
            chatAttachmentsEnabled={capabilities.chatAttachmentsEnabled}
            authEnabled={capabilities.authEnabled}
            historyEnabled={capabilities.historyEnabled}
            toolsCount={capabilities.toolsCount}
          />
        </div>
      )}
    </button>
  );
}
